class FreeShippingBar extends HTMLElement {
  constructor() {
    super();
  }

  static get selectors() {
    return {
      progressBar: "progress-bar",
      message: "free-shipping-bar-message"
    }
  }

  static get attributes() {
    return {
      threshold: "threshold",
      totalPrice: "total-price",
      message: {
        reached: "reached-message",
        unreached: "unreached-message"
      }
    }
  }

  static get observedAttributes() {
    return [
      this.attributes.threshold,
      this.attributes.totalPrice
    ];
  }

  get threshold() {
    return parseFloat(this.getAttribute(FreeShippingBar.attributes.threshold));
  }

  set threshold(value) {
    this.setAttribute(FreeShippingBar.attributes.threshold, value);
  }

  get totalPrice() {
    return parseFloat(this.getAttribute(FreeShippingBar.attributes.totalPrice));
  }

  set totalPrice(value) {
    this.setAttribute(FreeShippingBar.attributes.totalPrice, value);
  }

  async connectedCallback() {
    this.threshold = this.getAttribute(FreeShippingBar.attributes.threshold);

    document.addEventListener("cart:change", this.onCartChange.bind(this));
  }

  disconnectedCallback() {
    document.removeEventListener("cart:change", this.onCartChange.bind(this));
  }

  async attributeChangedCallback(attribute, oldValue, newValue) {
    await window.customElements.whenDefined("progress-bar");

    const progressBarElement = this.querySelector(FreeShippingBar.selectors.progressBar);

    if (!progressBarElement) {
      return false;
    }

    switch (attribute) {
      case FreeShippingBar.attributes.threshold:
        progressBarElement.valueMax = newValue;
        break;
      case FreeShippingBar.attributes.totalPrice:
        progressBarElement.valueNow = newValue;
        break;
    }

    this.updateMessage();
  }

  async onCartChange(event) {
    const items = (event?.detail?.cart ?? event?.detail)?.items;

    if (!items?.length) {
      return false;
    }

    this.totalPrice = items
      .filter((item) => item.requires_shipping)
      .reduce((sum, item) => sum + item.final_line_price, 0);
  }

  updateMessage() {
    const messageElement = this.querySelector(FreeShippingBar.selectors.message);

    if (!messageElement) {
      return false;
    }

    if (this.totalPrice >= this.threshold) {
      return messageElement.innerHTML = this.getAttribute(FreeShippingBar.attributes.message.reached);
    }

    const remainingAmount = this.threshold - this.totalPrice;

    return messageElement.innerHTML = this.getAttribute(FreeShippingBar.attributes.message.unreached).replace(new RegExp("{{\\s*[^{}]+\\s*}}", "g"), theme.Shopify.formatMoney(remainingAmount, theme.money_format));
  }
}

if (!customElements.get("free-shipping-bar")) {
  customElements.define("free-shipping-bar", FreeShippingBar);
}
